import * as React from 'react';
import { Icon } from "office-ui-fabric-react";
import { ISuggestedSubentity } from '../../../entities/Subentities';
import './SuggestedReason.css'

type Props = {
    entity?: ISuggestedSubentity,
}

const SuggestedReason = (props: Props) => {
    const { entity } = props;

    return entity?.suggestionReason
        ? <div className="suggested-reason">
            <div className="suggested-reason-header">
                <Icon iconName="PPMXAiGenerated" />
                <span className="title">Suggested Reason</span>
            </div>
            <div>{entity.suggestionReason}</div>
        </div>
        : <></>
}

export default SuggestedReason;